import { apiSlice } from '../api-slice'
import { ENDPOINTS } from '../endpoints'

const extendedApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        enablePushNotifications: builder.mutation<void, { token: string }>({
            query: ({ token }) => ({
                method: 'PUT',
                url: ENDPOINTS.PUSH_NOTIFICATIONS.PUT.ON,
                data: { token },
            }),
        }),
        disablePushNotifications: builder.mutation<void, { token: string }>({
            query: ({ token }) => ({
                method: 'PUT',
                url: ENDPOINTS.PUSH_NOTIFICATIONS.PUT.OFF,
                data: { token },
            }),
        }),
    }),
})

export const { useEnablePushNotificationsMutation, useDisablePushNotificationsMutation } = extendedApi
